module.exports = __webpack_public_path__ + "static/ProximaNovaExCn-Bold-923909b8f1f6139a44837dde7782fe0b.woff";